import {AgencyInfo } from "./components/agency/AgencyInfo";
import {AgencyPointSettings } from "./components/agency/AgencyPointSettings";
import {AgencyDefaults } from "./components/agency/AgencyDefaults";
import {AgencyEnrolmentBehaviour } from "./components/agency/AgencyEnrolmentBehaviour";
import {AgencyLicenseConfig } from "./components/agency/AgencyLicenseConfig";
import {AgencyAccreditationFields } from "./components/agency/AgencyAccreditationFields";
import {AgencyUserRelationshipFields } from "./components/agency/AgencyUserRelationshipFields";
import {AgencyProfessionCodes} from "./components/agency/AgencyProfessionCodes";

const AgencyUI = props => {

  const {
    value,
  } = props

  //console.log(JSON.parse(value))

  const tangibleFields = window.tangibleFields
  return (
    <div className="tgbl-agency-ui">

      <div className="tgbl-agency-info-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Agency Info</h2></div>
        <AgencyInfo
          value={JSON.parse(value)}
        />
      </div>

      <div className="tgbl-point-types-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Point Types</h2></div>
        <AgencyPointSettings
          value={JSON.parse(value)}
        />
      </div>

      {/*}
      <div className="tgbl-agency-default-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Agency Defaults</h2></div>
        <AgencyDefaults
          value={JSON.parse(value)}
        />
      </div>
      */}


      <div className="tgbl-agency-enrolment-behaviour-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Enrollment Behaviour</h2></div>
        <AgencyEnrolmentBehaviour
          value={JSON.parse(value)}
        />
      </div>

      <div className="tgbl-agency-regions-served-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Regions Served</h2></div>
        <AgencyLicenseConfig
          value={JSON.parse(value)}
        />
      </div>

      <div className="tgbl-agency-accreditation-fields-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Accreditation Fields</h2></div>
        <AgencyAccreditationFields
          value={JSON.parse(value)}
        />
      </div>

      <div className="tgbl-agency-user-relationship-fields-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>User Accrediting Agency Relationship Meta</h2></div>
        <AgencyUserRelationshipFields
          value={JSON.parse(value)}
        />
      </div>

    </div>
  )
}

export {AgencyUI}
